export default {
  affiliate: {
    // Main navigation
    title: '제휴',
    cantFindQuestion: '질문을 찾을 수 없나요?',
    onlineService: '온라인 서비스',
    dashboard: '대시보드',
    myRewards: '내 보상',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: '초대 보상',
    rules: '규칙',

    // Team Info
    teamData: '팀 데이터',
    details: '세부정보',
    totalValidFriends: '총 유효 친구:',
    todayTotalWager: '오늘 총 베팅:',
    rewards: '보상',

    // Commission rates
    inviteFriendsCommissionUpTo: '친구 초대 커미션 최대',
    expandTeamBonus: '팀 확장 보너스',
    maxLevelCommission: '최대 레벨 커미션',
    inviteFriendsCommission: '친구 초대 커미션',
    maxPerformanceCommission: '최대 성과 커미션',
    unlimitedAgent: '무제한 에이전트',
    unlimitedCommission: '무제한 커미션',
    commissionRate: '커미션 비율',

    // Team Invite Friends
    inviteFriendsToEarn: '친구를 초대하여 수익 창출',
    link: '링크',
    code: '코드',
    inviteFriends: '친구 초대',
    share: '공유',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: '청구',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: '오늘 받음',
    
    // Live Rewards
    liveRewards: '라이브 보상',
    sendTotalCommission: '총 커미션 전송',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: '오늘 초대한 친구',
    todayDepositFriends: '오늘 입금한 친구',
    depositFriends: '입금한 친구',
    validFriends: '유효한 친구',

    // Dialogs
    howMakeFriendsSubordinates: '친구를 하위 사용자로 만드는 방법:',
    shareInvitationLink: '초대 링크를 공유하여 등록하도록 합니다.',
    shareInvitationCode: '초대 코드를 공유하여 등록 시 입력하도록 합니다.',
    shareQRCode: 'QR 코드를 공유하여 스캔하고 등록하도록 합니다.',
    depositFriendsDescription: '하위 친구가 입금에 성공하면 입금 친구가 됩니다.',
    howMakeFriendsValidUsers: '친구를 유효 사용자로 만드는 방법:',
    successfullyInviteFriends: '친구 가입 초대 성공.',
    cumulativeDepositsReach: '누적 입금액이 10.00 USDT에 도달합니다.',
    cumulativeValidBetsReach: '누적 유효 베팅액이 50.00 USDT에 도달합니다.',
    thenBecomeValidUsers: '그러면 유효 사용자가 됩니다.',

    // Share Dialog
    shareTitle: '공유',
    player: '플레이어',
    saveImage: '이미지 저장',
    saveImageSuccess: "이미지가 저장되었습니다",
    saveImageFailed: "저장 실패, 다시 시도해 주세요",
    copy: '복사',
    copied: '복사됨!',

    // Received/Withdraw
    received: '받음',
    withdraw: '출금',
    history: '기록',
    referralRewards: '추천 보상',
    commission: '커미션',
    depositRebate: '입금 리베이트',
    levelUpRewards: '레벨업 보상',
    loading: '로딩 중...',
    noMoreRecords: '더 이상 기록이 없습니다',
    loadMore: '더 보기',
    pending: '대기 중',
    paid: '지급됨',
    rejected: '거부됨',
    unknown: '알 수 없음',
    upgradeReward: '레벨업 보상',
    cancelled: '취소됨',
    receiving: '수령 중',
    failed: '실패',
    expired: '만료됨',

    // History Dialog
    pickDate: '날짜 선택',
    select: '선택',
    chooseBonus: '보너스 선택',
    all: '전체',

    // Invitation Rewards Page
    inviteFriendToGet: '친구를 초대하여 받기',
    yourFriendGet: '친구가 받음',
    inviteFriendsEarnRewards: '친구를 초대하고 보상 받기',
    dailyInvitations: '일일 초대',

    // Rules - How to earn
    howToEarnAffiliateRewards: '제휴 보상을 받는 방법은?',
    shareToFriends: '친구에게 공유',
    shareReferralLink: '추천 링크, 코드 또는 QR 코드를 친구와 공유',
    friendsSignUpDeposit: '친구가 가입하고 입금',
    inviteFriendsRegisterDeposit: '친구를 AFUN에 등록하고 첫 입금을 하도록 초대합니다.',
    getUpTo: '최대 받기',
    earnBigRewards: '친구가 베팅, 입금하고 VIP에 도달하면 보상과 커미션을 받으세요.',
    noticeEnsureCorrect: '알림: 초대 링크, QR 코드 또는 코드가 올바른지 확인하세요.',

    // Rules - Commission Work
    howCommissionWork: '커미션은 어떻게 작동하나요?',
    agentRatingDescription: '에이전트 등급 설명',
    you: '당신',
    commissionDescription: '친구 B, C, D 및 그 이하의 입금과 베팅에서 커미션을 받으세요. 커미션 비율은 오른쪽 표를 참조하세요.',
    claimConditions: '청구 조건',
    teamLevel: '팀 레벨',
    earnUpTo: "Earn up to",
    expandYourTeam: "팀 확장하기",
    earnAnExtra: "추가로 획득",
    upgradeAgentLevel: "에이전트 등급 올리기",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: '총 크기',
    teamWager: '팀 베팅',
    rebateRewardVary: '리베이트 보상 및 충전 보상은 해당 날짜의 팀 레벨에 따라 다릅니다.',
    teamSizeDescription: '팀 규모: 현재 보유한 유효 사용자 수입니다.',
    teamBettingDescription: '팀 베팅: 하위 사용자가 하루에 하는 베팅의 총 수입니다.',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: '팀 커미션',
    teamCommissionSubTitle: '네트워크의 모든 입금과\n모든 베팅에서 수익을 얻으세요.',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: '친구를 초대하면 둘 다 보상을 받습니다',
    inviteRegisterReceive: '친구 등록 초대 성공 및 받기',
    friendDepositWagerUnlock: '친구가 10.00 USDT를 입금하고 50.00 USDT를 베팅하면 3.00 USDT 보상이 잠금 해제되고 친구는 2.00 USDT를 받습니다.',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: '최근 초대한 친구',
    recentDepositFriends: '최근 입금한 친구',
    today: '오늘',
    yesterday: '어제',
    thisMonth: '이번 달',
    friendsData: '친구 데이터',
    joinDate: '가입일',
    search: '검색',
    level: '레벨',
    tier: '티어',
    affiliateTreasureBox: '제휴 보물 상자',
    referralRewardsDesc: '친구를 초대하여 등록하면 당신과 친구 모두 푸짐한 보너스를 받습니다.',
    commissionDesc: '당신과 팀이 함께 목표를 달성하고 푸짐한 커미션을 받습니다.',
    affiliateTreasureBoxDesc: '친구를 초대하여 마일스톤 보너스를 받으세요',
  }
};
